import { gql } from '@apollo/client';
import { PartnerOrganizationInfo } from '../fragments';

export default gql`
  query partnerOrganization($id: ID) {
    partnerOrganization(id: $id) {
      ...PartnerOrganizationInfo
    }
  }
  ${PartnerOrganizationInfo}
`;
